export default __webpack_public_path__ + "static/media/pexels-daniel-frank-305564.f15c1a36.jpg";